import React from 'react';

import { SupportedProcessors } from '../../../constants';

import { CreditCardForm } from './CreditCardForm';
import { TokenexCardForm } from './TokenexCardForm';

import type { CreditCardFormProps } from './creditCard.types';

export const GenericCardForm = React.forwardRef(
  (props: CreditCardFormProps, ref) =>
    !props.processor ||
    props.processor === SupportedProcessors.DLOCAL ||
    props.processor === SupportedProcessors.TOKENEX ||
    props.processor === SupportedProcessors.PAYU ? (
      <TokenexCardForm {...props} ref={ref} />
    ) : (
      <CreditCardForm {...props} ref={ref} />
    ),
);
